<template>
    <div>
        <h3>Students</h3>

        <b-form-group class="student-search">
            <autocomplete ref="autocomplete"
                            :source="apiEndpoint"
                            results-property="asuriteId"
                            :resultsDisplay="studentDisplay"
                            inputClass="form-control"
                            @selected="selectStudent"
                            credentials="include"
                            :request-headers="requestHeaders"></autocomplete>
        </b-form-group>
    </div>
</template>
<script>
export default {
  data() {
    return {
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  computed: {
    apiEndpoint: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Students/FindStudent?query=";
    }
  },

  methods: {
    // formatted display for student selection
    studentDisplay: function(student) {
      return (
        student.asuriteId + " - " + student.firstName + " " + student.lastName
      );
    },

    // when student is selected from list, navigate to their profile page
    selectStudent: function(result) {
      this.$router.push({
        name: "student",
        params: { asuriteId: result.selectedObject.asuriteId }
      });
    }
  }
};
</script>
<style>
.student-search {
  max-width: 500px;
}
</style>
